"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.default = void 0;
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var _colors = _interopRequireDefault(require("./colors"));
var _functions = _interopRequireDefault(require("./functions"));
var _mixins = _interopRequireDefault(require("./mixins"));
var _typography = _interopRequireDefault(require("./typography"));
var _variables = _interopRequireDefault(require("./variables"));
var _zIndex = _interopRequireDefault(require("./zIndex"));
/*:: import { type ThemeType } from './ThemeTypes';*/
var theme /*: ThemeType*/ = exports.theme = {
  breakpoints: _breakpoints.default,
  colors: _colors.default,
  functions: _functions.default,
  mixins: _mixins.default,
  typography: _typography.default,
  variables: _variables.default,
  zIndex: _zIndex.default
};
var _default = exports.default = theme;
//# sourceMappingURL=theme.js.map